
﻿import { Component, OnInit,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../service/data.service';
import { UserService } from '../service/user.service';
import { User } from '../_models/user';
import { AlertService } from '../service/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BotDetectCaptchaModule } from 'angular-captcha';
import { CaptchaComponent } from 'angular-captcha';

import { MyDatePickerModule,IMyInputFocusBlur } from 'mydatepicker';
import { NgModule, ViewChild } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {IMyDpOptions, IMyDateModel, IMyOptions} from 'mydatepicker';
import { Observable } from 'rxjs';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpClient } from '@angular/common/http';
declare var getHexAscii: any;
@Component({
    templateUrl: 'register.component.html',
    styleUrls: ['./register.component.css'],
    providers: [DataService]
})
export class RegisterComponent  implements OnInit 
{
  messageForcustnumber: string;

  user: User = new User();
    model: any = {};
    loading = false;
    rForm: FormGroup;
    nextPage:Boolean;
    backpage :Boolean;
    returnUrl: string;
    regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    regchar='/^[a-zA-Z]+$/';
    regexpspace=/\s+/;
    regZeroOnly='^[0][0]*[0]$';
    msgforcustnoonly:string;
    msgforCustNoSpace:string;
    msgforCustNoSplChar:string;
    messageForAccNoreq:string;
    msgforAccNoSpace:string;
    msgforAccNoSplChar:string;
    msgforAccnNonly:string;
    msgforAccNoLen:string;
    messageFormMobNoreq:string;
    msgforMobNoSpace:string;
    msgforMobNoSplChar:string;
    msgforMobNonly:string;
    msgforMobNoLen:string;
    messageNewUserreq:string;
    msgforNewUserNoSpace:string;
    messageConfUserreq:string;
    msgforConfUserNoSpace:string;
    messageFormNewPassreq:string;
    msgforNewPassSplChar:string;
    msgforNewPassLen:string;
    messageForOneCapital:string;
    messageForOneNumber:string;
    msgforNewPassSpace:string;
    msgConfPassrequired:string;
    confpassNotMatch:string;
    msgOtprequired:string;
    captchatNoblank:string;
    msgForDateReq:string;
    incorrectCaptcha:string;
    Errorflagac:string="no";
      Errorflagdate:string="no";
     Errorflagcap:string="no";
     Errorflagmob:string="no";
     regNum = '^[0-9]*$';
    regexcap =/^.*?[A-Z]/;
     Errorflag:string="no"; 
      Errorflag1:string="no";
      isError = 'false';
    errorDescription = ' ';
  isLoad = false;
   placeholder: string;
   email:string;
   custname:string;
   isError1="false";
   NextBtnDisabled:boolean=false;
   subBtnDisabled:boolean=false;
 mytime:Date = new Date();
    currentYear:any= this.mytime.getUTCFullYear();
    currentDate:any= this.mytime.getUTCDate()+1;
    currentMonth:any= this.mytime.getUTCMonth() + 1;
  msgforConfUserNoMatch:string='';
  msgfornewUserSplChar:string='';
 myDatePickerOptions: IMyDpOptions = {
        inline: false,
        dateFormat: 'dd-mm-yyyy',
        editableDateField:false,
        disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate}
    };
  bankName: Observable<string>;
  contactUsPage: string;
  atmBranch: string;


 
    constructor(
      private spinnerService: Ng4LoadingSpinnerService,
        private router: Router,
        private fb: FormBuilder,
        private userService: UserService,
         private route: ActivatedRoute,
          private webService: CallBackEndService,      
        private alertService: AlertService,
        private http:HttpClient )       
     {
      this.bankName = webService.getBankName();
      this.getJSON().subscribe(data => {
        this.atmBranch = data.atmBranch;
        this.contactUsPage = data.contactUsPage;
       });    
      
      this.backpage=true;
      this.nextPage=false;
      this.Errorflag="no";
      this.Errorflagac="no";
      this.Errorflagdate="no";
      this.Errorflagcap="no";
      this.Errorflagmob="no";
      this.Errorflag1="no";
      this.rForm = fb.group({
      'custnumber' : [null, Validators.required],
      'accno' : [null, Validators.required],
       'mobno' : [null, Validators.required],
        'date' : [null, Validators.required],
         'captcha' : [null, Validators.required],
          'captchaInput' : [null, Validators.required], 
            'username' : [null, Validators.required],  
            'newPassword' : [null, Validators.required],  
            'confirmUserName' : [null, Validators.required], 
             'confPassword' : [null, Validators.required],
               'OTP' : [null, Validators.required], 
                 
       });
     }
      public getJSON(): Observable<any> {
        return this.http.get('assets/SampleUrl.json'); 
      }
ngOnInit() {
  
            console.log("register.111..."+this.returnUrl);
                 this.getCaptcha();
                 this.changePlaceholder();
                 this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/show-success';

}
    register() {
       this.subBtnDisabled=true;
     console.log("register...."+this.returnUrl);
       
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      let date1=this.rForm.controls['date'];
      let date2=date1.value;

    let newuser=this.rForm.controls['username'];
    let confuser=this.rForm.controls['confirmUserName'];
    let newPass=this.rForm.controls['newPassword'];
     let confpass:string=this.rForm.controls['confPassword'].value; 
     let otp=this.rForm.controls['OTP'];
    if (newuser.value === '' ||newuser.value===' ' ||newuser.value===undefined||newuser.value===null) 
    {
     this.messageNewUserreq = 'no';

   }else if(newuser.value.match(this.regexpspace))
    {
      this.msgforNewUserNoSpace='no';
     }else if(newuser.value.match(this.regsplchar))
    {
      this.msgfornewUserSplChar= 'no';
     
     }else if (confuser.value === '' ||confuser.value===' ' ||confuser.value===undefined||confuser.value===null) 
    {
     this.messageConfUserreq = 'no';
     }else if(confuser.value.match(this.regexpspace))
    {
      this.msgforConfUserNoSpace='no';
       
     }else if(!(confuser.value===newuser.value))
    {
      this.msgforConfUserNoMatch='no';
     
    } else if (newPass.value === '' ||newPass.value===' ' ||newPass.value===undefined||newPass.value===null) 
    {
     this.messageFormNewPassreq = 'no';
    }else if(newPass.value.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
     }else if(!newPass.value.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
       
     }else if(newPass.value.length<8)
    {
      this.msgforNewPassLen = 'no';
       this.Errorflag1="no";
     }
     else if(newPass.value.length>16)
    {
      this.msgforNewPassLen = 'no';
    }
      else  if(!newPass.value.match(this.regexcap))
    {
      this.messageForOneCapital='no';
    }
      else if(!newPass.value.match(".*\\d+.*"))
    {
      this.messageForOneNumber='no';
    }else if (this.rForm.controls['confPassword'].value === '' ||this.rForm.controls['confPassword'].value===' ' ||this.rForm.controls['confPassword'].value===undefined||this.rForm.controls['confPassword'].value===null) 
    {
     this.msgConfPassrequired='no';
       this.Errorflag1="no";
    }else if(!(newPass.value===confpass))
      {
      this.confpassNotMatch='no';
      this.Errorflag1="no";
    }else
    if (otp.value === '' ||otp.value===' ' ||otp.value===undefined||otp.value===null) 
    {
     this.msgOtprequired = 'no';
      this.Errorflag1="no";
   }
    else{
      this.spinnerService.show();
       let dob=date2['date'].day+"-"+this.getMonthName(date2['date'].month)+"-"+date2['date'].year;
       console.log("dob--"+dob);
       let otherInfo1=[this.rForm.get("accno").value,this.custname,this.rForm.get("custnumber").value,this.email,this.rForm.get("mobno").value,dob];
        var otherInfo={
               'acctNo15Digit' : this.rForm.get("accno").value,
               'custName' : this.custname,
               'custNo' :this.rForm.get("custnumber").value,
               'emailId' : this.email,
                'mobileNo' :this.rForm.get("mobno").value,
                 'dob' :dob
         };
         console.log("otherinfo---"+JSON.stringify(otherInfo)+"****Otherinfo1"+JSON.stringify(otherInfo1));
      request.param1 = getHexAscii('',this.rForm.get("OTP").value+this.rForm.get("username").value+this.rForm.get("newPassword").value+otherInfo);
      request.param2 = this.rForm.get("OTP").value;
      request.param3 = this.rForm.get("username").value;
      request.param4 = this.rForm.get("newPassword").value;
       request.param5 = "";
      request.param6=otherInfo;
       //request.param5 =date2['formatted'];
       
       console.log("param5---"+request.param5);
      
      this.webService.getResponse(request, 'registerNewUser').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        if (response.status === 'S200') {
         sessionStorage.setItem('showSuccessMsg', response.param1);
         this.router.navigate(['/show-success']);
        } else if (response.status === 'S101') {
          alert('Malicious Request Detected');
          this.isLoad = false;
        } else {
          this.isError1 = 'true';
          // tslint:disable-next-line:no-unused-expression
          response.statusDescription;
          this.subBtnDisabled=false;
          this.errorDescription = response.param1;
          this.isLoad = false;
        }
      });
    }
  }
clearForm()
{
 // this.rForm.setValue({custnumber: '',accno: '',mobno: '',date:'',captcha: '',password:''});
  this.rForm.get("custnumber").reset();
  this.rForm.get("accno").reset();
  this.rForm.get("mobno").reset();
  this.rForm.get("date").reset();
  this.rForm.get("captchaInput").reset();
  this.rForm.get("username").reset();
  this.rForm.get("newPassword").reset();
  this.rForm.get("confirmUserName").reset();
  this.rForm.get("confPassword").reset();
  this.rForm.get("OTP").reset();
  this.errorDescription = ' ';
  this.msgForDateReq='';
}
goToLink1(){
  window.open(this.atmBranch,'_blank');

}
goToLink2(){
  
  window.open(this.contactUsPage,'_blank'); 

}
showNextPage()
  { 
   console.log('sctivate spinner at click check-------');
    //this.spinnerService.show();
      let date1=this.rForm.controls['date'];
        let date2=date1.value;
    if(this.rForm.controls['custnumber'].value==='""'||this.rForm.controls['custnumber'].value==='" "'||this.rForm.controls['custnumber'].value==='"  "' ||this.rForm.controls['custnumber'].value===undefined||this.rForm.controls['custnumber'].value===null) {    
     this.validateCustNo();
    }else if(this.rForm.controls['accno'].value==='""'||this.rForm.controls['accno'].value==='" "'||this.rForm.controls['accno'].value==='"  "' ||this.rForm.controls['accno'].value===undefined||this.rForm.controls['accno'].value===null) {    
     this.validateAccNO();
    }else if(this.rForm.controls['mobno'].value==='""'||this.rForm.controls['mobno'].value==='" "'||this.rForm.controls['mobno'].value==='"  "' ||this.rForm.controls['mobno'].value===undefined||this.rForm.controls['mobno'].value===null) {    
     this.validateMobNO();
    }
   else if (date2==='""'||date2==='" "'||date2==='"  "' ||date2===undefined||date2===null) 
     {
       this.msgForDateReq = 'no';
     }  else if (this.rForm.controls['captchaInput'].value === '' ||this.rForm.controls['captchaInput'].value===' ' ||this.rForm.controls['captchaInput'].value===undefined||this.rForm.controls['captchaInput'].value===null) 
    {
     this.captchatNoblank = 'no';
      this.Errorflagcap="no";
      console.log("Errorflagcap-2----------"+this.Errorflagcap);
   }else if(this.rForm.controls['captchaInput'].value!= this.rForm.controls['captcha'].value.split(' ').join(''))
     {
      this.incorrectCaptcha='no';
       this.Errorflagcap="no";
       console.log("Errorflagcap-3----------"+this.Errorflagcap);
    }
     else{ 
       console.log('spinn er start---------------')
     this.spinnerService.show();
     this.errorDescription ="";
     this.NextBtnDisabled=true;
     const request: IbRequest = new IbRequest();
     let response: IbResponse = null;
      this.isLoad = true;
    
        request.param5=date2['date'].day+"-"+this.getMonthName(date2['date'].month)+"-"+date2['date'].year;
      request.param1 = getHexAscii('',  this.rForm.get("accno").value+this.rForm.get("custnumber").value+this.rForm.get("mobno").value+request.param5);
      request.param2 = this.rForm.get("accno").value;
      request.param3 = this.rForm.get("custnumber").value;
      request.param4 = this.rForm.get("mobno").value;
       //request.param5 =date2['formatted'];
      
       console.log("param5---"+request.param5+"@@@request.param2---"+request.param2+"@request.param3--"+request.param3+"@ request.param4---"+ request.param4);
      
       this.webService.getResponse(request, 'validateNewUser').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        if (response.status === 'S200') {
          this.email=response.param3;
          this.custname=response.param2;
            this.backpage=false;
            this.nextPage =true;
              console.log("next Page"+this.nextPage); 
        } else if (response.status === 'S101') {
          alert('Malicious Request Detected');
          this.isLoad = false;
        } else {
          this.isError = 'true';
          this.NextBtnDisabled=false;
          // tslint:disable-next-line:no-unused-expression
          response.statusDescription;
          this.errorDescription = response.param1;
          this.isLoad = false;
        }
      });
    }
  }
  openBackPage()
  {
    this.backpage=true;
    this.getCaptcha();
    this.rForm.get("captchaInput").reset();
    this.errorDescription ="";
    this.Errorflagcap='no';
    this.NextBtnDisabled=false;
  }
    validateConfPassword()
  {
    let newpass:string=this.rForm.controls['newPassword'].value;
    let confpass:string=this.rForm.controls['confPassword'].value; 
    if (this.rForm.controls['confPassword'].value === '' ||this.rForm.controls['confPassword'].value===' ' ||this.rForm.controls['confPassword'].value===undefined||this.rForm.controls['confPassword'].value===null) 
    {
     this.msgConfPassrequired='no';
       this.Errorflag1="no";
    }else if(!(newpass===confpass))
      {
      this.confpassNotMatch='no';
      this.Errorflag1="no";
    }else{
      this.Errorflag1="yes";
    }
    
  }
  clearConfPassword()
  {
    this.msgConfPassrequired='';
    this.confpassNotMatch='';
     
  }
  
  
validateCustNo()
  {
  
    console.log("in validation");
    let custno=this.rForm.controls['custnumber'];
    if (custno.value === '' ||custno.value===' '||custno.value===undefined||custno.value===null) 
    {
     console.log("In iff"+custno.value);
     this.messageForcustnumber = 'no';
     this.Errorflag="no";
   }else if(custno.value.match(this.regexpspace))
    {
      this.msgforCustNoSpace= 'no';
      this.Errorflag="no";
     }else if(custno.value.match(this.regsplchar))
    {
      this.msgforCustNoSplChar= 'no';
      this.Errorflag="no";
     }else if(!custno.value.match(this.regNum))
    {
      this.msgforcustnoonly = 'no';
      this.Errorflag="no";
     }else{
       this.Errorflag="yes";
     }
    
     console.log("Errorflag-----------"+this.Errorflag);
  }
  clearCustNo()
  {
     this.messageForcustnumber='';
    this.msgforcustnoonly = '';
    this.msgforCustNoSplChar='';
    this.msgforCustNoSpace= '';
  }
  validateAccNO()
  {
     let accno1=this.rForm.controls['accno'];
    if (accno1.value === '' ||accno1.value===' ' ||accno1.value===undefined||accno1.value===null) 
    {
     this.messageForAccNoreq = 'no';
     this.Errorflagac="no";
   }else if(accno1.value.match(this.regexpspace))
    {
      this.msgforAccNoSpace= 'no';
      this.Errorflagac="no";
     }else if(accno1.value.match(this.regsplchar))
    {
      this.msgforAccNoSplChar= 'no';
      this.Errorflagac="no";
     }else if(!accno1.value.match(this.regNum))
    {
      this.msgforAccnNonly = 'no';
      this.Errorflagac="no";
     }else if(accno1.value.length>15||accno1.value.length<15)
    {
      this.msgforAccNoLen = 'no';
      this.Errorflagac="no";
     }else{
       this.Errorflagac="yes";
     }
     console.log("Errorflagac-----------"+this.Errorflagac);
  }  
  
  clearAccNo()
  {
    this.messageForAccNoreq = '';
    this.msgforAccNoSpace='';
    this.msgforAccNoSplChar='';
    this.msgforAccnNonly='';
    this.msgforAccNoLen='';
  }
  validateMobNO()
  {
    console.log("mob no.");
     let mobno1=this.rForm.controls['mobno'];
    if (mobno1.value === '' ||mobno1.value===' ' ||mobno1.value===undefined||mobno1.value===null) 
    {
     this.messageFormMobNoreq = 'no';
     this.Errorflagmob="no";

   }else if(mobno1.value.match(this.regexpspace))
    {
      this.msgforMobNoSpace= 'no';
      this.Errorflagmob="no";
     }else if(mobno1.value.match(this.regsplchar))
    {
      this.msgforMobNoSplChar= 'no';
      this.Errorflagmob="no";
     }else if(!mobno1.value.match(this.regNum))
    {
      this.msgforMobNonly = 'no';
      this.Errorflagmob="no";
     }else if(mobno1.value.length>10||mobno1.value.length<10)
    {
      this.msgforMobNoLen = 'no';
      this.Errorflagmob="no";
     }else{
       this.Errorflagmob="yes";
     }
     console.log("Errorflagmob-----------"+this.Errorflagmob);
  }  
  
  clearMobNo()
  {
    this.messageFormMobNoreq='';
    this.msgforMobNoSpace='';
    this.msgforMobNoSplChar='';
    this.msgforMobNonly='';
    this.msgforMobNoLen='';
  }
  
  validateNewUserName()
  {
    let newuser=this.rForm.controls['username'];
    if (newuser.value === '' ||newuser.value===' ' ||newuser.value===undefined||newuser.value===null) 
    {
     this.messageNewUserreq = 'no';
      this.Errorflag1="no";

   }else if(newuser.value.match(this.regexpspace))
    {
      this.msgforNewUserNoSpace='no';
       this.Errorflag1="no";
     }if(newuser.value.match(this.regsplchar))
    {
      this.msgfornewUserSplChar= 'no';
     
     }else{
        this.Errorflag1="yes";
     }
  
  }
  clearNewUserName()
  {
    this.messageNewUserreq='';
     this.msgforNewUserNoSpace='';
     this.msgfornewUserSplChar= '';
  }
  validateConfUserName()
  {
    let confuser=this.rForm.controls['confirmUserName'];
    let newuser=this.rForm.controls['username'];
    if (confuser.value === '' ||confuser.value===' ' ||confuser.value===undefined||confuser.value===null) 
    {
     this.messageConfUserreq = 'no';
      this.Errorflag1="no";

   }else if(confuser.value.match(this.regexpspace))
    {
      this.msgforConfUserNoSpace='no';
       this.Errorflag1="no";
     }else if(!(confuser.value===newuser.value))
    {
      this.msgforConfUserNoMatch='no';
      this.Errorflag1="no";
    }
    else{
        this.Errorflag1="yes";
     }
  }
  clearConfUserName()
  {
    this.messageConfUserreq='';
    this.msgforConfUserNoSpace='';
    this.msgforConfUserNoMatch='';
  }
  validateNewPassword()
  {
    let newPass=this.rForm.controls['newPassword'];
    if (newPass.value === '' ||newPass.value===' ' ||newPass.value===undefined||newPass.value===null) 
    {
     this.messageFormNewPassreq = 'no';
      this.Errorflag1="no";

   }else if(newPass.value.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
       this.Errorflag1="no";
     }else if(!newPass.value.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
       this.Errorflag1="no";
     }else if(newPass.value.length<8)
    {
      this.msgforNewPassLen = 'no';
       this.Errorflag1="no";
     }
     else if(newPass.value.length>16)
    {
      this.msgforNewPassLen = 'no';
      this.Errorflag1="no";
    }
      else  if(!newPass.value.match(this.regexcap))
    {
      this.messageForOneCapital='no';
       this.Errorflag1="no";
    }
      else if(!newPass.value.match(".*\\d+.*"))
    {
      this.messageForOneNumber='no';
       this.Errorflag1="no";
    }else{
       this.Errorflag1="yes";
    }
  }
  clearNewPassword()
  {
     this.messageFormNewPassreq="";
      this.msgforNewPassSpace='';
      this.msgforNewPassSplChar="";
      this.msgforNewPassLen="";
      this.messageForOneCapital="";
      this.messageForOneNumber="";
  }
   validateOtp()
  {
    let otp=this.rForm.controls['OTP'];
    if (otp.value === '' ||otp.value===' ' ||otp.value===undefined||otp.value===null) 
    {
     this.msgOtprequired = 'no';
      this.Errorflag1="no";
   }else{
      this.Errorflag1="yes";
   }
  
  }
  clearOtp()
  {
    this.msgOtprequired='';
  }

 getCaptcha () {
//$rootScope.counter = 180;
      var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
                             'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
                             'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
                              'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
                              'u', 'v', 'w', 'x', 'y', 'z');
      var i;
      for (i = 0; i < 6; i++) {
             var a = alpha[Math.floor(Math.random() * alpha.length)];
             var b = alpha[Math.floor(Math.random() * alpha.length)];
              var c = alpha[Math.floor(Math.random() * alpha.length)];
              var d = alpha[Math.floor(Math.random() * alpha.length)];
             var e = alpha[Math.floor(Math.random() * alpha.length)];
             var f = alpha[Math.floor(Math.random() * alpha.length)];
              var g = alpha[Math.floor(Math.random() * alpha.length)];
       }
      var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f
                + ' ' + g;
                let captcha1= this.rForm.controls['captcha'];
                console.log(' captcha1-------------  '+captcha1);
               captcha1.setValue(code);
}
validateCaptcha()
  {
    console.log("Errorflagcap-1----------"+this.Errorflagcap);
    let captcha=this.rForm.controls['captchaInput'];
    let captchaWithoutSpaceNew = this.rForm.controls['captcha'].value.split(' ').join('');
    if (captcha.value === '' ||captcha.value===' ' ||captcha.value===undefined||captcha.value===null) 
    {
     this.captchatNoblank = 'no';
      this.Errorflagcap="no";
      console.log("Errorflagcap-2----------"+this.Errorflagcap);
   }else if(captcha.value!==captchaWithoutSpaceNew)
     {
      this.incorrectCaptcha='no';
       this.Errorflagcap="no";
       console.log("Errorflagcap-3----------"+this.Errorflagcap);
    }
   
   else{
      this.Errorflagcap="yes";
      console.log("Errorflagcap--4---------"+this.Errorflagcap);
   }
  console.log("Errorflagcap-----------"+this.Errorflagcap);
  }
  clearCaptcha()
  {
    this.captchatNoblank='';
    this.incorrectCaptcha='';
  }
  changePlaceholder() {
        this.placeholder = 'Enter Date Of Birth';
    }
    checkSpinner(){
    this.spinnerService.show();
    }
  onDateChanged(event: IMyDateModel) {
    //console.log("event date---"+JSON.stringify(event.formatted));
     let date1=JSON.stringify(event.formatted);
    //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
     if(event==null){
       this.msgForDateReq = 'no';
     this.Errorflagdate="no";
     }
     else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
     this.msgForDateReq = 'no';
     this.Errorflagdate="no";
   }else{
       this.Errorflagdate="yes";
        this.msgForDateReq='';
   }
     
    }
        getMonthName(month) 
{ 
return ["Jan","Feb","Mar","Apr","May","June","Jul","Aug","Sep", "Oct","Nov","Dec"][Number(month)-1];
}
}






// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/register/register.component.ts